/* AFS B2B — quote list, saved lists, and compare tray.
   Guest persistence: localStorage. Account/company-shared lists require the
   platform integration documented in docs/GAPS_AND_PLATFORM_DEPENDENCIES.md. */
(function () {
  'use strict';

  var cfg = window.AFSConfig || { pages: {}, features: {} };

  function store(key, fallback) {
    return {
      get: function () {
        try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (e) { return fallback; }
      },
      set: function (value) {
        try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* unavailable */ }
        document.dispatchEvent(new CustomEvent('afs:lists-updated', { detail: { key: key } }));
      }
    };
  }

  var quoteStore = store('afs:quote-list', []);
  var listsStore = store('afs:saved-lists', {});
  var compareStore = store('afs:compare', []);

  /* Item shape: { handle, variantId, title, sku, brand, image, url, price, uom, qty } */
  function readItemData(el) {
    var raw = el.getAttribute('data-product');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function findQty(el) {
    var scope = el.closest('[data-product-scope]') || document;
    var input = scope.querySelector('input[name="quantity"]');
    return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
  }

  /* ---------- Quote list ---------- */
  var Quote = {
    items: quoteStore.get,
    count: function () {
      return quoteStore.get().reduce(function (n, i) { return n + 1; }, 0);
    },
    add: function (item, qty) {
      var items = quoteStore.get();
      var existing = items.find(function (i) { return String(i.variantId) === String(item.variantId); });
      if (existing) existing.qty += qty;
      else items.push(Object.assign({}, item, { qty: qty }));
      quoteStore.set(items);
    },
    update: function (variantId, qty) {
      var items = quoteStore.get();
      var it = items.find(function (i) { return String(i.variantId) === String(variantId); });
      if (it) it.qty = Math.max(1, qty);
      quoteStore.set(items);
    },
    remove: function (variantId) {
      quoteStore.set(quoteStore.get().filter(function (i) { return String(i.variantId) !== String(variantId); }));
    },
    clear: function () { quoteStore.set([]); }
  };

  /* ---------- Saved lists ---------- */
  var Lists = {
    all: listsStore.get,
    create: function (name) {
      var lists = listsStore.get();
      var id = 'list-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (!id || id === 'list-') return null;
      if (!lists[id]) lists[id] = { name: name, items: [] };
      listsStore.set(lists);
      return id;
    },
    rename: function (id, name) {
      var lists = listsStore.get();
      if (lists[id]) { lists[id].name = name; listsStore.set(lists); }
    },
    remove: function (id) {
      var lists = listsStore.get();
      delete lists[id];
      listsStore.set(lists);
    },
    addItem: function (id, item, qty) {
      var lists = listsStore.get();
      if (!lists[id]) return;
      var existing = lists[id].items.find(function (i) { return String(i.variantId) === String(item.variantId); });
      if (existing) existing.qty += qty;
      else lists[id].items.push(Object.assign({}, item, { qty: qty }));
      listsStore.set(lists);
    },
    removeItem: function (id, variantId) {
      var lists = listsStore.get();
      if (!lists[id]) return;
      lists[id].items = lists[id].items.filter(function (i) { return String(i.variantId) !== String(variantId); });
      listsStore.set(lists);
    }
  };

  /* ---------- Compare (max 4) ---------- */
  var Compare = {
    items: compareStore.get,
    toggle: function (item) {
      var items = compareStore.get();
      var idx = items.findIndex(function (i) { return i.handle === item.handle; });
      if (idx >= 0) { items.splice(idx, 1); }
      else {
        if (items.length >= 4) { window.AFSToast('Compare holds up to 4 products. Remove one first.', { tone: 'error' }); return false; }
        items.push(item);
      }
      compareStore.set(items);
      return true;
    },
    remove: function (handle) {
      compareStore.set(compareStore.get().filter(function (i) { return i.handle !== handle; }));
    },
    clear: function () { compareStore.set([]); }
  };

  window.AFSB2B = { Quote: Quote, Lists: Lists, Compare: Compare };

  /* ---------- Header count bubbles ---------- */
  function refreshCounts() {
    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      var n = quoteStore.get().length;
      el.textContent = n > 0 ? String(n) : '';
      el.setAttribute('data-count', String(n));
    });
    document.querySelectorAll('[data-lists-count]').forEach(function (el) {
      var lists = listsStore.get();
      var n = Object.keys(lists).length;
      el.textContent = n > 0 ? String(n) : '';
      el.setAttribute('data-count', String(n));
    });
  }

  /* ---------- Compare tray ---------- */
  function refreshTray() {
    var tray = document.getElementById('CompareTray');
    if (!tray) {
      tray = document.createElement('div');
      tray.id = 'CompareTray';
      tray.className = 'compare-tray compare-tray--floating';
      tray.setAttribute('role', 'region');
      tray.innerHTML = '<div class="compare-tray__items"></div><a class="btn btn--primary compare-tray__go" href="/pages/compare">Compare</a>';
      document.body.appendChild(tray);
    }
    var items = compareStore.get();
    tray.classList.toggle('is-active', items.length > 0);
    var wrap = tray.querySelector('.compare-tray__items');
    if (!wrap) return;
    wrap.innerHTML = '';
    items.forEach(function (i) {
      var chip = document.createElement('span');
      chip.className = 'compare-tray__item';
      var label = document.createElement('span');
      label.textContent = i.title;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Remove ' + i.title + ' from comparison');
      btn.textContent = '×';
      btn.addEventListener('click', function () { Compare.remove(i.handle); });
      chip.appendChild(label);
      chip.appendChild(btn);
      wrap.appendChild(chip);
    });
    document.querySelectorAll('[data-compare-toggle]').forEach(function (el) {
      var data = readItemData(el);
      if (!data) return;
      var active = items.some(function (i) { return i.handle === data.handle; });
      el.setAttribute('aria-pressed', String(active));
      el.textContent = active ? (el.getAttribute('data-active-text') || 'In compare') : (el.getAttribute('data-idle-text') || 'Compare');
    });
  }

  /* ---------- Click handlers ---------- */
  document.addEventListener('click', function (e) {
    var addQuote = e.target.closest('[data-add-to-quote]');
    if (addQuote) {
      var item = readItemData(addQuote);
      if (item) {
        Quote.add(item, findQty(addQuote));
        window.AFSToast(addQuote.getAttribute('data-toast-text') || 'Added to quote list', {
          tone: 'success', linkHref: cfg.pages.quote || '#', linkText: 'View quote list'
        });
      }
      return;
    }

    var addList = e.target.closest('[data-add-to-list]');
    if (addList) {
      var itemL = readItemData(addList);
      if (!itemL) return;
      var lists = listsStore.get();
      var ids = Object.keys(lists);
      var name;
      if (ids.length === 0) {
        name = window.prompt(addList.getAttribute('data-prompt-new') || 'Name your first list (e.g. Monthly Restroom Supplies):');
        if (!name) return;
        var newId = Lists.create(name.trim());
        if (newId) Lists.addItem(newId, itemL, findQty(addList));
      } else {
        var menu = ids.map(function (id, i) { return (i + 1) + '. ' + lists[id].name; }).join('\n');
        var answer = window.prompt((addList.getAttribute('data-prompt-pick') || 'Add to which list? Enter a number, or type a new list name:') + '\n' + menu);
        if (!answer) return;
        var idx = parseInt(answer, 10);
        var targetId = (!isNaN(idx) && ids[idx - 1]) ? ids[idx - 1] : Lists.create(answer.trim());
        if (targetId) Lists.addItem(targetId, itemL, findQty(addList));
      }
      window.AFSToast(addList.getAttribute('data-toast-text') || 'Saved to list', {
        tone: 'success', linkHref: cfg.pages.savedLists || '#', linkText: 'View lists'
      });
      return;
    }

    var cmp = e.target.closest('[data-compare-toggle]');
    if (cmp) {
      var itemC = readItemData(cmp);
      if (itemC) Compare.toggle(itemC);
      return;
    }

    var clearCmp = e.target.closest('[data-compare-clear]');
    if (clearCmp) Compare.clear();
  });

  document.addEventListener('afs:lists-updated', function () { refreshCounts(); refreshTray(); });
  refreshCounts();
  refreshTray();
})();
